<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">

              @if (
                !form.get('products').at(0).get('parameters').get('nombreAdherents').value &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez sélectionner le nombre d'adhérents pour continuer
                </info>
              }
              @if (
                !form.get('products').at(0).get('parameters').get('projetMaternite').value &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez sélectionner le projet maternité et hospitalisation pour continuer
                </info>
              }
              @if (
                !form.get('products').at(0).get('parameters').get('couvertureActuelle').value &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si vous bénéficiez d'une complémentaire santé pour continuer
                </info>
              }
              @if (
                !form.get('products').at(0).get('parameters').get('eligibiliteCss').value &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer l'éligibilité à la CSS pour continuer
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('informeRisqueCumul').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client est informé du risque de cumul pour continuer
                </info>
              }

              <!-- Adhérents -->
              <div class="section-card">
                <div class="section-title">Adhérents</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="nombreAdherents"
                      columns="4"
                      [isDefault]="false"
                      label="Nombre d'adhérents"
                      [options]="nombreAdherentsOptions"
                    ></pr-input-radio>
                  </div>
                </div>
              </div>

              <!-- Optique -->
              <div class="section-card">
                <div class="section-title">Optique</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="optiqueActif"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label=""
                    ></pr-input-radio>
                  </div>
                </div>
                @if (
                  form.get('products').at(0).get('parameters').get('optiqueActif').value &&
                  form.get('products').at(0).get('parameters').get('optiqueVisions')?.value?.length === 0 &&
                  derrors
                ) {
                  <info [option]="optionWarning">
                    Vous devez sélectionner une vision pour continuer
                  </info>
                }
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Vision" [derrors]="derrors">
                      <pr-select-search
                        formControlName="optiqueVisions"
                        label="Vision"
                        [options]="optiqueVisionOptions"
                        optionDisplayKey="label"
                        optionValueKey="value"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinOptiqueLunettes"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin optique lunettes"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinOptiqueLentilles"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin optique lentilles"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="operationMyopie"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Opération myopie"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Budget souhaité pour l'opération" [derrors]="derrors" [suffix]="'€'">
                      <input formControlName="budgetOperationMyopie" type="text" placeholder="Ex : 2 000" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Notes" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="optiqueNotes" rows="2" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Dentaire -->
              <div class="section-card">
                <div class="section-title">Dentaire</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="dentaireActif"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label=""
                    ></pr-input-radio>
                  </div>
                </div>
                @if (
                  form.get('products').at(0).get('parameters').get('dentaireActif').value &&
                  form.get('products').at(0).get('parameters').get('dentaireSoins')?.value?.length === 0 &&
                  derrors
                ) {
                  <info [option]="optionWarning">
                    Vous devez sélectionner au moins un soin pour continuer
                  </info>
                }
                <div class="row mt-1">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted">Soins @if (form.get('products').at(0).get('parameters').get('dentaireActif').value) {<em>&#160;*</em>}</span>
                    <div class="checkbox">
                      <ng-template #default></ng-template>
                      <pr-checkbox-group
                        formControlName="dentaireSoins"
                        [template]="default"
                        [options]="dentaireSoinsOptions"
                      ></pr-checkbox-group>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinDentaire"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin dentaire"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="orthodontieEnfants"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Traitement d'orthodontie pour les enfants"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Notes" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="dentaireNotes" rows="2" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Soins courants -->
              <div class="section-card">
                <div class="section-title">Soins courants</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinSoinsCourants"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin soins courant"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Notes" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="soinsCourantsNotes" rows="2" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Hospitalisation -->
              <div class="section-card">
                <div class="section-title">Hospitalisation</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinHospitalisation"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin hospitalisation"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="projetMaternite"
                      columns="3"
                      [isDefault]="false"
                      label="Projet maternité et hospitalisation"
                      [options]="projetMaterniteOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Notes" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="hospitalisationNotes" rows="2" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Médecines douces -->
              <div class="section-card">
                <div class="section-title">Médecines douces</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="medecinesDoucesActif"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label=""
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="besoinMedecinesDouces"
                      columns="3"
                      [isDefault]="false"
                      label="Besoin de rendez-vous en médecines douces (ostéopathe, kiné, psychologue…)"
                      [options]="niveauBesoinOptions"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Notes" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="medecinesDoucesNotes" rows="2" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Couverture actuelle et risque de cumul -->
              <div class="section-card">
                <div class="section-title">Couverture actuelle et risque de cumul</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Bénéficiez-vous d'une complémentaire santé ?" [derrors]="derrors">
                      <pr-select-search
                        formControlName="couvertureActuelle"
                        label="Sélectionner"
                        [options]="couvertureActuelleOptions"
                        optionDisplayKey="label"
                        optionValueKey="value"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Éligibilité à la CSS" [derrors]="derrors">
                      <pr-select-search
                        formControlName="eligibiliteCss"
                        label="Sélectionner"
                        [options]="eligibiliteCssOptions"
                        optionDisplayKey="label"
                        optionValueKey="value"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
                @if (showCouvertureDetails) {
                  <div class="row mt-1">
                    <div class="col-md-6">
                      <pr-input-column label="Nature du contrat en cours" [derrors]="derrors">
                        <pr-select-search
                          formControlName="natureContratExistant"
                          label="Sélectionner"
                          [options]="natureContratExistantOptions"
                          optionDisplayKey="label"
                          optionValueKey="value"
                        ></pr-select-search>
                      </pr-input-column>
                    </div>
                    <div class="col-md-6">
                      <pr-input-column label="Motif de la demande" [derrors]="derrors">
                        <pr-select-search
                          formControlName="motifDemande"
                          label="Sélectionner"
                          [options]="motifDemandeOptions"
                          optionDisplayKey="label"
                          optionValueKey="value"
                        ></pr-select-search>
                      </pr-input-column>
                    </div>
                  </div>
                }
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="informeRisqueCumul"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Client informé du risque de cumul"
                    ></pr-input-radio>
                  </div>
                </div>
              </div>

              <!-- Enfants à rattacher au devis -->
              @if (showEnfants && enfantsOptions.length > 0) {
                <div class="section-card">
                  <div class="section-title">Enfants à rattacher au devis</div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="checkbox">
                        <ng-template #enfantsTemplate></ng-template>
                        <pr-checkbox-group
                          formControlName="enfantsRattachesIds"
                          [template]="enfantsTemplate"
                          [options]="enfantsOptions"
                        ></pr-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <!-- Notes générales -->
              <div class="section-card">
                <div class="section-title">Notes générales</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="notesGenerales" rows="3" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
